module.exports = __webpack_public_path__ + "static/atlas-hero-foreground-6a3bbaf2c3e52d50d2482420132bb130.png";